import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
import { getUser } from "../../../utils/commonfunction";

const getActiveRole = () => {
    const roles = [ROLE.SUPER_ADMIN, ROLE.SUB_ADMIN, ROLE.CLUB_ADMIN, ROLE.PLAYER, ROLE.PARENT, ROLE.NON_AFFILIATED_USER];
    for (const r of roles) {
        const u = getUser(r);
        if (u && u.token) return r;
    }
    return ROLE.SUPER_ADMIN;
};

export const getAuditLogs = async (userId, filters = {}) => {
    const activeRole = getActiveRole();
    const params = {};
    if (filters.startDate) params.startDate = filters.startDate;
    if (filters.endDate) params.endDate = filters.endDate;
    if (filters.action) params.action = filters.action;
    if (filters.search) params.search = filters.search;
    if (activeRole === ROLE.CLUB_ADMIN) {
        return await axiosInstance({ role: ROLE.CLUB_ADMIN }).get(`/club-admin/team-manager/${userId}/audit-logs`, { params });
    }
    return await axiosInstance({ role: ROLE.SUPER_ADMIN }).get(`/admin/audit-logs/${userId}`, { params });
}

export const getAuditLogDetail = async (logId) => {
    const activeRole = getActiveRole();
    if (activeRole === ROLE.CLUB_ADMIN) {
        return await axiosInstance({ role: ROLE.CLUB_ADMIN }).get(`/club-admin/team-manager/audit-logs/detail/${logId}`);
    }
    return await axiosInstance({ role: ROLE.SUPER_ADMIN }).get(`/admin/audit-logs/detail/${logId}`);
}

export const getAuditLogFilterList = async () => {
    const activeRole = getActiveRole();
    if (activeRole === ROLE.CLUB_ADMIN) {
        return await axiosInstance({ role: ROLE.CLUB_ADMIN }).get(`/club-admin/team-manager/audit-logs/filter-list`);
    }
    return await axiosInstance({ role: ROLE.SUPER_ADMIN }).get(`/admin/audit-logs/filter-list`);
}

export const downloadAuditLogs = async (userId, filters = {}, format = "pdf") => {
    const activeRole = getActiveRole();
    const params = { format };
    if (filters.startDate) params.startDate = filters.startDate;
    if (filters.endDate) params.endDate = filters.endDate;
    if (filters.action) params.action = filters.action;
    if (filters.search) params.search = filters.search;

    if (activeRole === ROLE.CLUB_ADMIN) {
        return await axiosInstance({ role: ROLE.CLUB_ADMIN }).get(`/club-admin/team-manager/${userId}/audit-logs/download`, {
            params,
            responseType: "blob",
        });
    }
    return await axiosInstance({ role: ROLE.SUPER_ADMIN }).get(`/admin/audit-logs/${userId}/download`, {
        params,
        responseType: "blob",
    });
};

